import { CheckDecagramIcon } from './CheckDecagramIcon';

/**
 * author: Michael Richins
 * id 64E327CF-3FCB-4742-AB82-789B2C27D31B
 * name check-decagram
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-decagram.svg
 * tags
 */
export const TickDecagramIcon = CheckDecagramIcon;
export default TickDecagramIcon